"use strict";

;
(function (ProductScentSelect, $) {
  var eventHandlers = function eventHandlers() {
    $('.mobile-swatches-dropdown').click(function () {
      $(this).find('.js-svg-down').toggleClass('is-open');
      $(this).find('.swatches-dropdown-container').slideToggle(500);
    });
  };
  ProductScentSelect.init = function () {
    eventHandlers();
  };
})(window.ProductScentSelect = window.ProductScentSelect || {}, jQuery, undefined);